import React from 'react';

import { cn } from 'utils/cn';

import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/Tooltip';

import { TriangleIcon } from 'components/Icons';

const BadgeText = ({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) => <span className={cn('text-xs font-medium', className)}>{children}</span>;

const ActiveDot = () => <div className='size-1.5 rounded-full bg-green' />;

const LabelText = ({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div
    className={cn('flex flex-row items-center justify-end gap-2', className)}
  >
    {children}
  </div>
);

export const RangeBadge = ({
  removed,
  inRange,
  className
}: {
  removed?: boolean;
  inRange?: boolean;
  className?: string;
}) => (
  <div className={cn('flex justify-end', className)}>
    {removed ? (
      <Tooltip delayDuration={0}>
        <TooltipTrigger>
          <LabelText className='text-red'>
            <BadgeText>Closed</BadgeText>

            <TriangleIcon className='size-4' />
          </LabelText>
        </TooltipTrigger>

        <TooltipContent
          className='z-modal max-w-60 text-wrap bg-blue-700'
          side='bottom'
        >
          Your position has 0 liquidity, and is not earning fees.
        </TooltipContent>
      </Tooltip>
    ) : inRange ? (
      <Tooltip delayDuration={0}>
        <TooltipTrigger>
          <LabelText className='text-green'>
            <BadgeText>In range</BadgeText>

            <ActiveDot />
          </LabelText>
        </TooltipTrigger>

        <TooltipContent
          className='z-modal max-w-60 text-wrap bg-blue-700'
          side='bottom'
        >
          The price of this pool is within your selected range. Your position is
          currently earning fees.
        </TooltipContent>
      </Tooltip>
    ) : (
      <Tooltip delayDuration={0}>
        <TooltipTrigger>
          <LabelText className='text-yellow'>
            <BadgeText>Out of range</BadgeText>

            <TriangleIcon className='size-4' />
          </LabelText>
        </TooltipTrigger>

        <TooltipContent
          className='z-modal max-w-60 text-wrap bg-blue-700'
          side='bottom'
        >
          The price of this pool is outside of your selected range. Your
          position is not currently earning fees.
        </TooltipContent>
      </Tooltip>
    )}
  </div>
);
